import NewUserDetailsForm from './NewUserDetailsForm'

export default NewUserDetailsForm
